import { createAction, props } from '@ngrx/store';

export const loadCountries = createAction('[List] Load Countries');

export const loadCountriesSuccess = createAction(
  '[List] Load Countries Success',
  props<{ countries: any[] }>()
);

export const loadCountriesFailure = createAction(
  '[List] Load Countries Failure',
  props<{ error: any }>()
);
